import { IPagedQuery } from "@rentiohq/shared-frontend/dist/reduxV2/utils/api.types";

export interface IContactOrMeMaster {
  // The contact whose lists are shown. Undefined while it is not known yet.
  contactId?: number;
  // Me master is still loading, so the contact is not known yet.
  isFetching: boolean;
  // Me master could not be loaded, so the contact will not be known.
  fetchError?: Error;
}

// A route param as a contact id: undefined when the route has none or it is not a number.
export const toContactId = (routeParam?: string) => {
  const contactId = Number(routeParam);

  return routeParam && Number.isFinite(contactId) ? contactId : undefined;
};

/**
 * The contact a contact-scoped list is about: the route's contact, or the office's own (me
 * master) on the routes without one, such as /company/... Me master may not be loaded on the
 * first render, and a request built before it is goes out as /contacts/undefined/...
 */
export const resolveContactOrMeMaster = (params: {
  routeContactId?: number;
  meMaster: { id?: number; isFetching?: boolean; fetchError?: Error };
}): IContactOrMeMaster => {
  const { routeContactId, meMaster } = params;

  if (routeContactId != null) {
    return { contactId: routeContactId, isFetching: false };
  }

  if (meMaster.id != null) {
    return { contactId: meMaster.id, isFetching: false };
  }

  if (meMaster.fetchError) {
    return { isFetching: false, fetchError: meMaster.fetchError };
  }

  return { isFetching: meMaster.isFetching === true };
};

/**
 * The paged-hook params for a list under /contacts/:id/<segment>. Without a contact id there is
 * no path and no query, so the hook sends nothing until the id is known.
 */
export const getContactListPagedParams = (params: {
  contactId?: number;
  segment: string;
  query: IPagedQuery;
}) => {
  const { contactId, segment, query } = params;

  if (contactId == null) {
    return { shouldRefetch: true };
  }

  return {
    shouldRefetch: true,
    customPath: `/contacts/${contactId}/${segment}`,
    query,
  };
};
